<template>
	<div class="threeImagesUp">
		<div class="row">
			<div class="col-12">
				<banner :priority="1"></banner>
			</div>
			<div class="col-12">
				<banner :priority="2"></banner>
			</div>
			<div class="col-12">
				<banner :priority="3"></banner>
			</div>
		</div>
	</div>

</template>

<script>


	import Banner from '@/components/parts/Banner';
	export default {
		name: "sidebar-banners",
		components: {
			Banner
		}
	}
</script>

<style lang="scss">

	.tiles.threeImages.sidebar{
		padding: 0;
		background-color: none;
	}

	.threeImagesUp {
		.itemHolder {
			height: 260px;
			margin-bottom: 25px;
			width: 100%;
			background-size: cover;
			background-position: center bottom;
			position: relative;
		}
		.blockHolder {
			position: absolute;
			top: 100px;
			left: 30px;
			color: #fff
		}
		.textHolder {
			padding-top: 0;
			margin-top: 0;
		}
		h2 {
			font-size: 34px;
			padding-bottom: 20px;
			margin-bottom: 15px;
			position: relative;
			font-weight: 700;
			&:before {
				height: 5px;
				width: 90px;
				position: absolute;
				bottom: 0;
				left: 0;
				background-color: #fff;
				content: '';
			}
		}
	}
</style>